import { useMemo } from 'react';
import { useFirstActivationDateMs } from '@atlassian/jira-tenant-context-controller/src/components/first-activation-date-ms/index.tsx';

const dayInMs = 1000 * 60 * 60 * 24;

// Only runs the comparison once during the component's lifecycle.
export const useIsFirstActivationDateAfterOneDayMemo = () => {
	const firstActivationDate = useFirstActivationDateMs();
	const isAfterOneDay = useMemo(() => {
		if (!firstActivationDate) {
			return false;
		}
		return (Date.now() - firstActivationDate) / dayInMs >= 1;
	}, [firstActivationDate]);
	return isAfterOneDay;
};
